// src/utils/language/routeUtils.ts
import { routesConfig } from "../../../app/routes"

// Normalize slugs (strip slashes + lowercase)
const normalize = (s = "") => s.replace(/^\/+|\/+$/g, "").toLowerCase()

export const getRouteKeyFromPath = (pathname: string, currentLang: string): string | null => {
  // strip query/hash, trailing slash, split
  const clean = pathname.split(/[?#]/)[0].replace(/\/$/, "")
  const segments = clean.split("/").filter(Boolean)
  // no slug → home
  if (segments.length < 2) return "home"
  // join after lang
  const slug = normalize(segments.slice(1).join("/"))
  if (!slug) return "home"

  for (const route of routesConfig) {
    const target = route.paths[currentLang] ?? route.paths["en"] ?? ""
    if (normalize(target) === slug) return route.key
  }

  return null
}

export const getLocalizedPath = (routeKey: string, targetLang: string): string => {
  const route = routesConfig.find((r) => r.key === routeKey)
  if (!route) return `/${targetLang}`

  const raw = route.paths[targetLang] ?? ""
  const slug = normalize(raw)
  return `/${targetLang}${slug ? "/" + slug : ""}`
}
